import { render } from "./PromoBanner.vue?vue&type=template&id=24a443e3&scoped=true&bindings={\"promoImage\":\"data\",\"onImageError\":\"options\"}"
import script from "./PromoBanner.vue?vue&type=script&lang=js"
export * from "./PromoBanner.vue?vue&type=script&lang=js"

import "./PromoBanner.vue?vue&type=style&index=0&id=24a443e3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24a443e3"

export default script